/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachLinkIcon24Regular = forwardRef('AttachLinkIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M1 12a6 6 0 0 1 6-6h2.75a.75.75 0 0 1 0 1.5H7a4.5 4.5 0 0 0 0 9h2.75a.75.75 0 0 1 0 1.5H7a6 6 0 0 1-6-6Z" }),
        React.createElement("path", { d: "M23 12a6 6 0 0 0-6-6h-2.75a.75.75 0 0 0 0 1.5H17a4.5 4.5 0 1 1 0 9h-2.75a.75.75 0 0 0 0 1.5H17a6 6 0 0 0 6-6Z" }),
        React.createElement("path", { d: "M7.75 11.25a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z" })));
});
